'use client';

import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@phosphor-icons/react';
import { Airplane, Armchair, Barbell, Bicycle, Binoculars, Camera, CarSimple, Compass, Confetti, Drop, FlowerLotus, ForkKnife, GraduationCap, MapTrifold, Mountains, MusicNotes, PaintBrush, PawPrint, PersonSimpleHike, PersonSimpleRun, Sailboat, Snowflake, SoccerBall, Sparkle, Storefront, Sun, Ticket, Tree, Umbrella, Waves } from '@phosphor-icons/react';
import type { ComponentType } from 'react';
import type { PartnerProfileData } from '../_lib/partner-server';
const CATEGORY_ICONS: Record<string, ComponentType<IconProps>> = {
  adventure: Compass,
  airborne: Airplane,
  animals: PawPrint,
  aquatics: Waves,
  art_and_culture: PaintBrush,
  boats: Sailboat,
  cycling: Bicycle,
  eat_and_drink: ForkKnife,
  entertainment: Confetti,
  funsport: SoccerBall,
  guided_tours: Binoculars,
  hiking: PersonSimpleHike,
  indoor: Armchair,
  learning: GraduationCap,
  mountaineering: Mountains,
  music: MusicNotes,
  nature: Tree,
  on_wheels: CarSimple,
  outdoor: Sun,
  photography: Camera,
  relaxation: Umbrella,
  rent: Storefront,
  running: PersonSimpleRun,
  sightseeing: MapTrifold,
  sport: Barbell,
  tickets: Ticket,
  wellness: Drop,
  winter_sports: Snowflake,
  yoga: FlowerLotus
};
const MAX_VISIBLE_CATEGORIES = 4;
type PartnerCategoriesProps = {
  categories: PartnerProfileData['categories'];
};
export function PartnerCategories(t0) {
  const $ = _c(6);
  const {
    categories
  } = t0;
  if (categories.length === 0) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] !== categories) {
    const visibleCategories = categories.slice(0, MAX_VISIBLE_CATEGORIES);
    t1 = "flex flex-col gap-3";
    t2 = visibleCategories.map(_temp);
    $[0] = categories;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(category) {
  const Icon = CATEGORY_ICONS[category.key] ?? Sparkle;
  return <li key={category.key} className="flex items-center gap-4"><span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-sand text-primary"><Icon className="size-[18px]" aria-hidden={true} /></span><span className="font-body-copy">{category.label}</span></li>;
}